import React from "react";
import notfoundImage from "assets/images/notfound.png";
import styled from "styled-components";
import { RouteComponentProps } from "@reach/router";

interface ExceptionProps extends RouteComponentProps {
  primaryText: string;
  othersText: React.ReactNode[];
}

export const ExceptionContainer = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
  margin: 0 auto;
`;

export const CenterElementOnParent = styled("div")`
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
`;

export const FormatPrincipalText = styled("h1")`
  font-weight: bold;
  margin: 35px 0px 10px 0px;
`;

export const FormatSubText = styled("div")`
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #212121;
`;

export default function Exception({ primaryText, othersText }: ExceptionProps) {
  return (
    <ExceptionContainer>
      <CenterElementOnParent>
        <img src={notfoundImage} alt="Not found illustration" />
        <FormatPrincipalText>{primaryText}</FormatPrincipalText>
        {othersText.map((text, key) => (
          <FormatSubText key={key}>{text}</FormatSubText>
        ))}
      </CenterElementOnParent>
    </ExceptionContainer>
  );
}
